var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return !_vm.isClosed
    ? _c(
        "div",
        {
          ref: "message",
          staticClass: "c-message",
          class: "c-message--" + _vm.type
        },
        [
          _c("div", { staticClass: "o-width-limiter" }, [
            _c("div", { staticClass: "c-message__content" }, [
              _c("p", [
                _vm.title !== ""
                  ? _c("strong", [_vm._v(_vm._s(_vm.title) + ": ")])
                  : _vm._e(),
                _c("span", {
                  domProps: {
                    innerHTML: _vm._s(decodeURIComponent(_vm.message))
                  }
                }),
                _vm._v(" "),
                _vm.readMore.url
                  ? _c(
                      "a",
                      {
                        staticClass: "c-message__read-more",
                        attrs: { href: _vm.readMore.url }
                      },
                      [_vm._v(_vm._s(_vm.readMore.text))]
                    )
                  : _vm._e()
              ]),
              _vm._v(" "),
              _vm.closable
                ? _c(
                    "button",
                    {
                      staticClass: "c-message__close",
                      attrs: { type: "button" },
                      on: {
                        click: function($event) {
                          return _vm.closeMessage()
                        }
                      }
                    },
                    [
                      _c("span", { staticClass: "t-visually-hidden" }, [
                        _vm._v("Stäng meddelande")
                      ]),
                      _vm._v(" "),
                      _c("v-icon", {
                        attrs: {
                          name: "icon-close-bold",
                          size: "xs",
                          cssModifiers: "c-message__close-icon"
                        }
                      })
                    ],
                    1
                  )
                : _vm._e()
            ])
          ])
        ]
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }